import { BellOff, TriangleAlert } from 'lucide-react';

import { Tooltip } from '../tooltip/tooltip';
import { TooltipContent } from '../tooltip/tooltip-content';
import { TooltipProvider } from '../tooltip/tooltip-provider';
import { TooltipTrigger } from '../tooltip/tooltip-trigger';

const reminderIconClass = (sentCount: number): string => {
    if (sentCount < 1) {
        return 'text-[#C8C8C8]';
    }
    if (sentCount === 1) {
        return 'text-[#E6B800]';
    }
    if (sentCount === 2) {
        return 'text-[#E67E22]';
    }
    return 'text-[#F24C41]';
};

export interface ReminderStatusIconProps {
    sentCount: number;
    hoverLabel: string;
    allowReminders: boolean;
    onOpen: () => void;
}

export const ReminderStatusIcon = ({
    sentCount,
    hoverLabel,
    allowReminders,
    onOpen,
}: ReminderStatusIconProps) => {
    if (!allowReminders) {
        return (
            <TooltipProvider delayDuration={200}>
                <Tooltip>
                    <TooltipTrigger asChild>
                        <span
                            className="inline-flex rounded p-0.5"
                            aria-label="Reminder Off"
                        >
                            <BellOff
                                className="h-4 w-4 text-[#C8C8C8]"
                                aria-hidden
                            />
                        </span>
                    </TooltipTrigger>
                    <TooltipContent color="dark" side="top">
                        Reminder Off
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        );
    }

    return (
        <TooltipProvider delayDuration={200}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <button
                        type="button"
                        onClick={onOpen}
                        className="inline-flex rounded p-0.5 hover:bg-black/4"
                        aria-label={`${hoverLabel}. Open payment overdue reminders`}
                    >
                        <TriangleAlert
                            className={`h-4 w-4 ${reminderIconClass(sentCount)}`}
                            aria-hidden
                        />
                    </button>
                </TooltipTrigger>
                <TooltipContent color="dark" side="top">
                    {hoverLabel}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};
